import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CreatePostForm from '../components/CreatePostForm/CreatePostForm';
import { Post } from '../types/api';
import './PostsPage.css';

interface CreatePostPageProps {
  onCreated?: (post: Post) => void;
}

/**
 * Thin wrapper around the shared CreatePostForm. The actual composer
 * lives in components/CreatePostForm so the Calendar's modal and the
 * Editor's "Use in post" handoff can render the same UI.
 */
export default function CreatePostPage({ onCreated }: CreatePostPageProps) {
  const [searchParams] = useSearchParams();
  const initialPostId = searchParams.get('postId');

  return (
    <div className="posts-page">
      <CreatePostForm initialPostId={initialPostId} onSaved={onCreated} />
    </div>
  );
}
